import BaseAdapter from "@/adapters/base";
import Upload from "@/models/Upload";
import {AxiosResponse, AxiosError, AxiosRequestConfig} from 'axios';
import store from '@/store';
import Letterbox from "@/models/Letterbox";
import User from "@/models/User";
import Vue from "vue";
import BillingEvent from "@/models/BillingEvent";

export default class SessionAdapter extends BaseAdapter {

    request(options: AxiosRequestConfig): any {
        //Overwrite auth if logged in
        if (!options.auth) {
            const auth = {
                username: store.state.account.username,
                password: store.state.account.masterHash,
            };
            Vue.$log.debug("Auth not found, inserting auth from store for this request", auth);
            options.auth = auth;
        } else {
            Vue.$log.debug("Auth for this request was specified", options.auth);
        }
        return super.request(options);
    }

    public getAccountInfo(username: string, masterHash: string): Promise<User> {
        Vue.$log.debug("SessionAdapter:getAccountInfo called", arguments);
        return new Promise(((resolve, reject) => {
            const url = `/account`;
            this.request({
                method: 'get',
                url,
                auth: {
                    username,
                    password: masterHash,
                },
            }).then((res: AxiosResponse) => {
                resolve(res.data);
            }).catch((error: AxiosError) => {
                reject(error);
            });
        }));
    }

    public getAccountLetterboxes(): Promise<Letterbox[]> {
        return new Promise(((resolve, reject) => {
            const url = `/letterboxes/list`;
            this.request({
                method: 'get',
                url,
            }).then((res: AxiosResponse) => {
                resolve(res.data);
            }).catch((error: AxiosError) => {
                reject(error);
            });
        }));
    }

    public getAccountUploads(): Promise<Upload[]> {
        return new Promise(((resolve, reject) => {
            const url = `/uploads/list`;
            this.request({
                method: 'get',
                url,
            }).then((res: AxiosResponse) => {
                resolve(res.data);
            }).catch((error: AxiosError) => {
                reject(error);
            });
        }));
    }

    public deleteLetterbox(id: string): Promise<void> {
        return new Promise(((resolve, reject) => {
            const url = `/letterboxes/${id}`;
            this.request({
                method: 'delete',
                url,
            }).then((res: AxiosResponse) => {
                resolve(res.data);
            }).catch((error: AxiosError) => {
                reject(error);
            });
        }));
    }

    public deleteUpload(id: string): Promise<void> {
        return new Promise(((resolve, reject) => {
            const url = `/uploads/${id}`;
            this.request({
                method: 'delete',
                url,
            }).then((res: AxiosResponse) => {
                resolve(res.data);
            }).catch((error: AxiosError) => {
                reject(error);
            });
        }));
    }

    public changePassword(u: User): Promise<User> {
        return new Promise(((resolve, reject) => {
            const url = `/account`;
            this.request({
                method: 'post',
                url,
                data: u,
            }).then((res: AxiosResponse) => {
                resolve(res.data);
            }).catch((error: AxiosError) => {
                reject(error);
            });
        }));
    }

    public async changeExpiry(id: string, newDate: Date) {
        const newUpload = new Upload();
        newUpload.expiry = newDate;
        newUpload.id = id;
        const url = `uploads/${id}/expiration`;
        const result: AxiosResponse = await this.request({
            method: 'post',
            url,
            data: newUpload,
        });
        return result.data;
    }}
